export const INTERCOM_LAUNCHER_HEIGHT = 60 + 20; // height - 60, bottom - 20;
